// utils/navigateService.js

let navigateFunction = null;

export const setNavigate = (navigate) => {
    navigateFunction = navigate;
};

export const getNavigate = () => {
    if (!navigateFunction) {
        throw new Error('navigateFunction 尚未初始化');
    }
    return navigateFunction;
};
